module.exports = __webpack_public_path__ + "media/images/diy/arrow_down-0762b7f72808a1d14f5e48f54680f6a5.svg";